import { Component, Input, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { Consignment, GalleryDocument } from 'src/app/Services/consignment.service';

@Component({
    selector: 'consignment-data',
    templateUrl: './consignment-data.component.html',
    inputs: ['selectedConsignment'],
    standalone: false
})
export class ConsignmentDataComponent implements OnInit {
  public selectedConsignment!: Consignment;
  public statusItem = ['Pending', 'Catalogue', 'Delivery', 'Sales'];
  public commissionOptions: { value: number; label: string }[] = [];
  public artistConnectedGalleries: SelectItem[] = [];
  public artistId!: string;
  public consignmentId!: string;
  public artists: SelectItem[] = [];

  public ngOnInit(): void {
    console.log(this.selectedConsignment);
  }

  isToday(date: Date): boolean {
    const today = new Date();
    const providedDate = new Date(date);
    return providedDate.getFullYear() === today.getFullYear() && providedDate.getMonth() === today.getMonth() && providedDate.getDate() === today.getDate();
  }

  dispatchedDaysAgo(date: Date): number {
    const currentDate = new Date();
    const dispatchedDate = new Date(date);
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const daysAgo = Math.round(Math.abs((currentDate.getTime() - dispatchedDate.getTime()) / oneDay));
    return daysAgo;
  }

  public getDocumentsBySection(section: number): GalleryDocument[] {
    if (!this.selectedConsignment?.GalleryTermsHistory?.GalleryDocuments) {
      return [];
    }
    return this.selectedConsignment.GalleryTermsHistory.GalleryDocuments.filter(
      doc => doc.Section === section
    );
  }

  public viewDocument(filePath: string): void {
    if (filePath) {
      window.open(filePath, '_blank');
    }
  }
}